// import hooks
import { useEffect } from "react";
import useMediaQuery from "../../../../hooks/useMediaQuery/index.js";
export const useSearchBarEffects = ({ ref, isOpen, searchFieldKey, open, mobileOpen, closeHandler, mobileCloseHandler, }) => {
    const isSmallDevice = useMediaQuery(({ breakpoints }) => breakpoints.down("expanded"));
    useEffect(() => {
        if (isOpen && searchFieldKey) {
            ref?.current?.focus();
        }
        else {
            ref?.current?.blur();
        }
    }, [isOpen, ref, searchFieldKey]);
    useEffect(() => {
        if (isSmallDevice && open)
            closeHandler();
        if (!isSmallDevice && mobileOpen)
            mobileCloseHandler();
    }, [isSmallDevice, mobileOpen, mobileCloseHandler, open, closeHandler]);
};
export default useSearchBarEffects;
